import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import routes from '~/routes';
import { PlainLink } from 'components/link';
import type { DcaScenarioRow } from './types';

const columnHelper = createColumnHelper<DcaScenarioRow>();

export const dcaScenariosColumns: ColumnDef<DcaScenarioRow, any>[] = [
  columnHelper.accessor('name', {
    id: 'name',
    header: 'DCA Scenario Name',
    size: 180,
    enableSorting: true,
    cell: (info) => {
      const row = info.row.original;
      return (
        <PlainLink href={`${routes.dcaScenariosPath}/${row.id}`}>
          {info.getValue()}
        </PlainLink>
      );
    },
  }),
  columnHelper.accessor('notes', {
    id: 'notes',
    header: 'Notes',
    size: 340,
    enableSorting: true,
    meta: { type: 'text', wrap: true },
  }),
  columnHelper.accessor('area_count', {
    id: 'area_count',
    header: 'Area Count',
    size: 150,
    enableSorting: true,
    meta: { align: 'left', type: 'integer' },
  }),
  columnHelper.accessor('formation_count', {
    id: 'formation_count',
    header: 'Formation Count',
    size: 150,
    enableSorting: true,
    meta: { align: 'left', type: 'integer' },
  }),
  columnHelper.accessor('development_type', {
    id: 'development_type',
    header: 'Development Type',
    size: 160,
    enableSorting: true,
    cell: (info) => {
      const v = info.getValue() as string | undefined;
      if (!v) return '—';
      const label =
        {
          ALL: 'All',
          HORIZONTAL: 'Horizontal',
          VERTICAL: 'Vertical',
        }[v.toUpperCase()] ?? v;
      return label;
    },
  }),
  columnHelper.accessor('segmentation', {
    id: 'segmentation',
    header: 'Segmentation',
    size: 160,
    enableSorting: true,
    meta: { type: 'text' },
  }),
  columnHelper.accessor('outlier_detection', {
    id: 'outlier_detection',
    header: 'Outlier Detection',
    size: 180,
    enableSorting: true,
    meta: { type: 'text' },
  }),
  columnHelper.accessor('early_time_on', {
    id: 'early_time_on',
    header: 'Early Time',
    size: 125,
    enableSorting: true,
    cell: (info) => (info.getValue() ? 'Yes' : 'No'),
  }),
  columnHelper.accessor('oil_configs_count', {
    id: 'oil_configs_count',
    header: 'Oil Configs',
    size: 140,
    enableSorting: true,
    meta: { align: 'left', type: 'integer' },
  }),
  columnHelper.accessor('gas_configs_count', {
    id: 'gas_configs_count',
    header: 'Gas Configs',
    size: 140,
    enableSorting: true,
    meta: { align: 'left', type: 'integer' },
  }),
  columnHelper.accessor('water_configs_count', {
    id: 'water_configs_count',
    header: 'Water Configs',
    size: 140,
    enableSorting: true,
    meta: { align: 'left', type: 'integer' },
  }),
  columnHelper.accessor('created_at', {
    id: 'created_at',
    header: 'Created At',
    size: 230,
    enableSorting: true,
    meta: { type: 'date' },
  }),
  columnHelper.accessor('created_by', {
    id: 'created_by',
    header: 'Created By',
    size: 150,
    enableSorting: true,
    meta: { type: 'text' },
  }),
  columnHelper.accessor('updated_at', {
    id: 'updated_at',
    header: 'Updated At',
    size: 230,
    enableSorting: true,
    meta: { type: 'date' },
  }),
  columnHelper.accessor('updated_by', {
    id: 'updated_by',
    header: 'Updated By',
    size: 150,
    enableSorting: true,
    meta: { type: 'text' },
  }),
];
